/* Bridal Lingerie Consultation — scroll reveal + auto-rotating step cards */
(function () {
  'use strict';

  function init() {
    var animated = document.querySelectorAll('.reveal-up, .reveal-left, .reveal-right');

    if ('IntersectionObserver' in window && animated.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { root: null, rootMargin: '0px', threshold: 0.15 });

      animated.forEach(function (el) { observer.observe(el); });
    } else {
      // Fallback: reveal everything
      animated.forEach(function (el) { el.classList.add('active'); });
    }

    // Auto-rotate "How it works" step cards
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-bridal-steps]').forEach(function (group) {
      var cards = group.querySelectorAll('.bridal-step');
      if (!cards.length || reduceMotion) return;

      var interval = parseInt(group.getAttribute('data-interval'), 10) || 2500;
      var current = 0;

      setInterval(function () {
        cards.forEach(function (card) { card.classList.remove('active-step'); });
        cards[current].classList.add('active-step');
        current = (current + 1) % cards.length;
      }, interval);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
